import { isFn, isCollectionType } from './checkers';
import { RawProxy, ProxyRaw, MakeObservableSymbol, RawShallowProxy, } from './environment';
import { baseHandlers, collectionHandlers } from './handlers';
import { buildDataTree } from './datatree';
import { isObservable, isSupportObservable } from './externals';
export var createProxy = function (target, shallow) {
    var proxy = new Proxy(target, isCollectionType(target) ? collectionHandlers : baseHandlers);
    ProxyRaw.set(proxy, target);
    if (shallow) {
        RawShallowProxy.set(target, proxy);
    }
    else {
        RawProxy.set(target, proxy);
    }
    return proxy;
};
export var createObservable = function (target, key, value, shallow) {
    if (target) {
        var parentRaw = ProxyRaw.get(target) || target;
        var isShallowParent = RawShallowProxy.get(parentRaw);
        if (isShallowParent)
            return value;
    }
    if (isObservable(value))
        return value;
    if (isSupportObservable(value)) {
        buildDataTree(target, key, value);
        return createProxy(value, shallow);
    }
    return value;
};
export function createAnnotation(maker) {
    var annotation = function (target) {
        return maker({ value: target });
    };
    if (isFn(maker)) {
        annotation[MakeObservableSymbol] = maker;
    }
    return annotation;
}
export function getObservableMaker(target) {
    if (target[MakeObservableSymbol]) {
        if (!target[MakeObservableSymbol][MakeObservableSymbol]) {
            return target[MakeObservableSymbol];
        }
        return getObservableMaker(target[MakeObservableSymbol]);
    }
}
